import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initCause1uc19zhi9fkfi as initCause } from './internal/StackTraceRecovery.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from './Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine } from './internal/Scopes.mjs';
import {
  get_delaynv5kl66dta33 as get_delay,
  DelayWithTimeoutDiagnostics19ibxwhhgbjz0 as DelayWithTimeoutDiagnostics,
} from './Delay.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { disposeOnCompletion1zvxmj809ax5i as disposeOnCompletion } from './Job.mjs';
import { startUndispatchedOrReturnIgnoreTimeout3dcuyudwff859 as startUndispatchedOrReturnIgnoreTimeout } from './intrinsics/Undispatched.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancen5e0rps4ljgd as DurationUnit_MILLISECONDS_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *withTimeoutOrNull(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    return null;
  var coroutine = {_v: null};
  try {
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var timeoutCoroutine = new (TimeoutCoroutine())(timeMillis, uCont);
      coroutine._v = timeoutCoroutine;
      return setupTimeout(timeoutCoroutine, block);
    };
  } catch ($p) {
    if ($p instanceof TimeoutCancellationException()) {
      var e = $p;
      if (e.m17_1 === coroutine._v) {
        return null;
      }
      throw e;
    } else {
      throw $p;
    }
  }
}
var TimeoutCancellationExceptionClass;
function TimeoutCancellationException() {
  if (TimeoutCancellationExceptionClass === VOID) {
    class $ extends CancellationException() {
      static o17(message, coroutine) {
        var $this = this.n(message);
        captureStack($this, $this.n17_1);
        $this.m17_1 = coroutine;
        return $this;
      }
      static p17(message) {
        return this.o17(message, null);
      }
      h13() {
        var tmp0_elvis_lhs = this.message;
        // Inline function 'kotlin.also' call
        var this_0 = TimeoutCancellationException().o17(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this.m17_1);
        initCause(this_0, this);
        return this_0;
      }
    }
    initMetadataForClass($, 'TimeoutCancellationException', VOID, VOID, [CopyableThrowable()]);
    TimeoutCancellationExceptionClass = $;
  }
  return TimeoutCancellationExceptionClass;
}
var TimeoutCoroutineClass;
function TimeoutCoroutine() {
  if (TimeoutCoroutineClass === VOID) {
    class $ extends ScopeCoroutine() {
      constructor(time, uCont) {
        super(uCont.mc(), uCont);
        this.u17_1 = time;
      }
      q11() {
        this.mx(TimeoutCancellationException_0(this.u17_1, get_delay(this.wv_1), this));
      }
      kw() {
        return super.kw() + '(timeMillis=' + this.u17_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'TimeoutCoroutine', VOID, VOID, [Runnable()], [0]);
    TimeoutCoroutineClass = $;
  }
  return TimeoutCoroutineClass;
}
function setupTimeout(coroutine, block) {
  var cont = coroutine.zy_1;
  var context = cont.mc();
  disposeOnCompletion(coroutine, get_delay(context).j13(coroutine.u17_1, coroutine, coroutine.wv_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics()) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.k13(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var message = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  return TimeoutCancellationException().o17(message, coroutine);
}
function *withTimeout(timeMillis, block, $completion) {
  if (timeMillis <= 0n)
    throw TimeoutCancellationException().p17('Timed out immediately');
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    return setupTimeout(new (TimeoutCoroutine())(timeMillis, uCont), block);
  };
}
//region block: exports
export {
  withTimeoutOrNull as withTimeoutOrNull3fn9ef0keo2ht,
  withTimeout as withTimeout3dbn27y1hxkws,
  TimeoutCancellationException as TimeoutCancellationException198b5zwr3v3uw,
};
//endregion

//# sourceMappingURL=Timeout.mjs.map
